"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var metrics_engine_1 = require("@tableau/metrics-engine");
var EmptyTimeSeries_1 = require("./EmptyTimeSeries");
var formatting_1 = require("../formatting/formatting");
var utils_1 = require("../utils");
var Localize_1 = require("../../gen-src/Localize");
var DetailTimeSeries_1 = require("./DetailTimeSeries");
var widgets_1 = require("@tableau/widgets");
var MetricLegend_1 = require("./MetricLegend");
var Colors = widgets_1.TabStyles.Colors;
var DEFAULT_HEIGHT = '510px';
var MetricDetailView = /** @class */ (function (_super) {
    __extends(MetricDetailView, _super);
    function MetricDetailView(props) {
        var _this = _super.call(this, props) || this;
        _this.onActivated = function (selectedValue) {
            _this.setState(function (state) {
                return {
                    selectedValue: selectedValue,
                };
            });
        };
        _this.renderComparisonDeltaAndTimestampArea = function (dateFormatter, measureAccessor, timestampAccessor, colorAccessor, comparisonMeasureAccessor, comparisonTimestampAccessor) {
            var _a;
            var delta = _this.comparisonDelta(measureAccessor, comparisonMeasureAccessor);
            var color = _this.props.metricColorIndicatorsEnabled ? delta && colorAccessor((_a = delta) === null || _a === void 0 ? void 0 : _a.comparedPoint) : metrics_engine_1.MetricsGrey;
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { "data-tb-test-id": 'measure-delta', style: __assign(__assign({}, measureDeltaStyle), { color: color }), role: 'img', "aria-label": _this.measureDeltaAccessibleLabel(delta) }, _this.measureDeltaText(delta)),
                React.createElement("div", { "data-tb-test-id": 'selected-point-timestamp', style: selectedTimeStyle, "aria-label": Localize_1.Messages.ariaLabelSelectedTime() }, _this.selectedTimestampOrTimeDelta(dateFormatter, delta, timestampAccessor, comparisonTimestampAccessor))));
        };
        _this.renderTimeSeries = function (dateFormatter, measureAccessor, colorAccessor, timestampAccessor, comparisonMeasureAccessor) {
            var _a, _b, _c;
            if (!utils_1.isSingleNumberMetric(_this.props.data) && timestampAccessor) {
                var lineStyle = metrics_engine_1.getLineStyleForDefaultThresholdLine(_this.props.definition);
                var comparisonLineInteractiveDot = !((_a = lineStyle) === null || _a === void 0 ? void 0 : _a.hidden) && ((_b = lineStyle) === null || _b === void 0 ? void 0 : _b.interactive);
                return (React.createElement(DetailTimeSeries_1.ResizableDetailTimeSeries, { testId: "time-series", data: _this.props.data, dateFormatter: dateFormatter, onActivated: _this.onActivated, formatString: _this.props.measureFormat, timestampAccessor: timestampAccessor, measureAccessor: measureAccessor, comparisonAccessor: comparisonMeasureAccessor, shouldRenderReferenceLine: _this.props.metricsReferenceLineEnabled ? metrics_engine_1.shouldRenderFirstThresholdLine(_this.props.definition) : false, comparisonLineStyle: metrics_engine_1.getStylePropsForDefaultThresholdLine(_this.props.definition), comparisonLineLabelAccessor: metrics_engine_1.buildComparisonLineLabelAccessor(_this.props.definition, _this.props.data), comparisonLineInteractiveDot: comparisonLineInteractiveDot, colorIndicatorsEnabled: (_c = _this.props.metricColorIndicatorsEnabled, (_c !== null && _c !== void 0 ? _c : false)), colorAccessor: colorAccessor }));
            }
            else {
                return React.createElement(EmptyTimeSeries_1.EmptyTimeSeries, null);
            }
        };
        _this.renderLegend = function (dateFormatter, timestampAccessor) {
            if (!utils_1.isSingleNumberMetric(_this.props.data) && timestampAccessor) {
                var dateRange = metrics_engine_1.getDateRange(_this.props.data);
                return dateRange && React.createElement(MetricLegend_1.MetricLegend, { currentRange: dateRange, dateFormatter: dateFormatter });
            }
            else {
                return null;
            }
        };
        var initialValue = utils_1.getBAN(_this.props.data, _this.props.lastUpdatedTimestamp);
        _this.state = {
            selectedValue: initialValue,
        };
        return _this;
    }
    MetricDetailView.prototype.render = function () {
        var _a;
        var measureAccessor = this.props.definition && metrics_engine_1.buildMeasureAccessor(this.props.definition);
        if (!measureAccessor) {
            return null;
        }
        var timestampAccessor = this.props.definition && metrics_engine_1.buildTimestampAccessor(this.props.definition);
        var comparisonMeasureAccessor = this.props.metricsReferenceLineEnabled && this.props.definition
            ? metrics_engine_1.buildFirstThresholdMeasureAccessor(this.props.definition)
            : undefined;
        var comparisonTimestampAccessor = this.props.definition && metrics_engine_1.buildFirstThresholdTimestampAccessor(this.props.definition);
        var colorAccessor = metrics_engine_1.buildColorAccessor(this.props.definition);
        var banColor = this.props.metricColorIndicatorsEnabled ? metrics_engine_1.MetricsGrey : metrics_engine_1.MetricBlue;
        var dateFormatter = metrics_engine_1.getDateFormatter(this.props.definition);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { "data-tb-test-id": this.props.testId, style: __assign(__assign({}, this.props.style), { height: (_a = this.props.height, (_a !== null && _a !== void 0 ? _a : DEFAULT_HEIGHT)), width: this.props.width, display: 'flex', flexFlow: 'column' }) },
                React.createElement("div", { style: { flexGrow: 0 } },
                    React.createElement("div", { "data-tb-test-id": 'metric-detail-value', style: __assign(__assign({}, detailValueStyle), { color: banColor }), "aria-label": Localize_1.Messages.ariaLabelSelectedValue() }, formatting_1.formatDataPointAsMetricNumber(measureAccessor, this.state.selectedValue, this.props.measureFormat)),
                    this.renderComparisonDeltaAndTimestampArea(dateFormatter, measureAccessor, timestampAccessor, colorAccessor, comparisonMeasureAccessor, comparisonTimestampAccessor)),
                React.createElement("div", { style: timeSeriesContainerStyle }, this.renderTimeSeries(dateFormatter, measureAccessor, colorAccessor, timestampAccessor, comparisonMeasureAccessor))),
            this.renderLegend(dateFormatter)));
    };
    MetricDetailView.getDerivedStateFromProps = function (nextProps, prevState) {
        var _a, _b;
        if (((_a = nextProps.lastUpdatedTimestamp) === null || _a === void 0 ? void 0 : _a.getTime()) !== ((_b = prevState.prevUpdatedTimestamp) === null || _b === void 0 ? void 0 : _b.getTime())) {
            var selectedValue = utils_1.getBAN(nextProps.data, nextProps.lastUpdatedTimestamp);
            return {
                selectedValue: selectedValue,
                prevUpdatedTimestamp: nextProps.lastUpdatedTimestamp,
            };
        }
        return {};
    };
    MetricDetailView.prototype.comparisonDelta = function (measureAccessor, comparisonMeasureAccessor) {
        var latestValue = this.state.selectedValue;
        return latestValue ? metrics_engine_1.computeMetricComparison(latestValue, measureAccessor, comparisonMeasureAccessor) : undefined;
    };
    MetricDetailView.prototype.measureDeltaText = function (delta) {
        if (!delta || !this.props.definition) {
            // Instead of an empty string, return an non-breaking space character
            // to maintain consistent vertical spacing of elements when no comparison delta is available.
            return NON_BREAKING_SPACE;
        }
        var comparisonText = metrics_engine_1.formatComparisonTextForDetail(delta, this.props.definition, this.props.measureFormat);
        var symbol = comparisonText.symbol || '';
        return symbol + comparisonText.text;
    };
    MetricDetailView.prototype.measureDeltaAccessibleLabel = function (delta) {
        if (!delta || !this.props.definition) {
            return '';
        }
        var comparisonText = metrics_engine_1.formatComparisonTextForDetail(delta, this.props.definition, this.props.measureFormat);
        var symbol = comparisonText.symbol || '';
        return symbol + comparisonText.text;
    };
    MetricDetailView.prototype.selectedTimestampOrTimeDelta = function (dateFormatter, delta, timestampAccessor, comparisonTimestampAccessor) {
        var timestamp = this.state.selectedValue && timestampAccessor && timestampAccessor(this.state.selectedValue);
        var comparisonTimestamp = delta && comparisonTimestampAccessor && comparisonTimestampAccessor(delta.comparedPoint);
        if (!comparisonTimestamp || !timestamp) {
            return timestamp ? dateFormatter.banTimestamp(timestamp) : '';
        }
        return dateFormatter.comparisonWidget(timestamp, comparisonTimestamp);
    };
    return MetricDetailView;
}(React.PureComponent));
exports.MetricDetailView = MetricDetailView;
exports.MetricRefreshTime = function (props) {
    return (React.createElement("div", { style: lastUpdatedStyle, "aria-label": Localize_1.Messages.ariaLabelLastRefresh() }, props.lastRefreshedTimestamp ? formatting_1.formatLastUpdatedDate(props.lastRefreshedTimestamp) : Localize_1.Messages.notUpdated()));
};
exports.MetricTitle = function (props) {
    return (React.createElement("div", { role: "heading", "aria-level": 1, "aria-label": Localize_1.Messages.ariaLabelMetricName(), "data-tb-test-id": "metric-title", style: titleStyle }, props.metricName));
};
var lastUpdatedStyle = {
    color: Colors.L9,
    fontSize: '12px',
};
var titleStyle = {
    color: Colors.L9,
    fontSize: '24px',
    lineHeight: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
var detailValueStyle = {
    marginTop: '12px',
    fontWeight: 300,
    fontSize: '48px',
    lineHeight: '1.2',
};
var selectedTimeStyle = {
    color: Colors.L9,
    fontSize: '14px',
    marginBottom: '12px',
    marginTop: '8px',
};
var measureDeltaStyle = {
    color: Colors.L9,
    fontSize: '20px',
    marginBottom: '12px',
    marginTop: '8px',
    lineHeight: '1.2',
};
var timeSeriesContainerStyle = {
    flex: '1 1',
    minHeight: 0,
};
var NON_BREAKING_SPACE = '\xa0';
//# sourceMappingURL=MetricDetailView.js.map